/** get all videos */
const getVideoElements = (): HTMLVideoElement[] => {
    return Array.from(document.getElementsByTagName("video"));
};

/** prevent simultaneous playback of multiple audio on video play  */
const handlePlay = (currentVideo: HTMLVideoElement): void => {
    if (currentVideo.muted === true) {
        currentVideo.muted = false;
    }
    getVideoElements().map((video) => {
        if (video !== currentVideo) {
            video.muted = true;
        }
    });
};

/** prevent simultaneous playback of multiple audio on volume change */
const handleVolumeChange = (currentVideo: HTMLVideoElement): void => {
    getVideoElements().map((video) => {
        if (video !== currentVideo && currentVideo.muted === false) {
            video.muted = true;
        }
    });
};

/** video control change */
const videoControlChange = (e: CustomEvent) => {
    if (
        e.detail.type === "play" &&
        e.detail.element.hasAttribute("data-autoplay") === false
    ) {
        handlePlay(e.detail.element);
    }
    if (e.detail.type === "volumechange") {
        handleVolumeChange(e.detail.element);
    }
};

/** pause all videos */
const pauseAllVideos = (): void => {
    getVideoElements().map((video) => {
        video.pause();
    });
};

export const initVideoControl = (): void => {
    /** Listen to video control change */
    window.addEventListener("uxVideoControlChange", videoControlChange);

    /** Listen to active tab event and pause videos on tab change */
    window.addEventListener("uxActiveTabSet", pauseAllVideos);

    /** Listen to previous slide event and pause videos on slide change */
    window.addEventListener("uxSliderPreviousSlide", pauseAllVideos);

    /** Listen to next slide event and pause videos on slide change */
    window.addEventListener("uxSliderNextSlide", pauseAllVideos);
};

export default initVideoControl;
